exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".total[data-v-2ca7025f] {\n  align-items: center;\n  border-top: 1px #d9d9d9 solid;\n  display: flex;\n  justify-content: space-between;\n  font-size: 18px;\n  font-weight: bold;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  padding-top: 10px;\n}\n.blank-error-message[data-v-2ca7025f] {\n  color: #ff5252 !important;\n}", ""]);

// exports
